import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'app-base-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  standalone: true,
  imports: [AvatarModule, CommonModule],
})
export class BaseAvatarComponent {
  @Input() label?: string;
  @Input() imageURL?: string;
  @Input() size?: string;
  @Input() shape?: string;
  @Input() image?: string;
}
